(function () {
    'use strict';

    var CACHE_TTL_MS = 5 * 60 * 1000;

    function cacheGet(key) {
        try {
            var raw = sessionStorage.getItem(key);
            if (!raw) return null;
            var parsed = JSON.parse(raw);
            if (!parsed || !parsed.expiresAt || parsed.expiresAt < Date.now()) {
                sessionStorage.removeItem(key);
                return null;
            }
            return parsed.data;
        } catch (e) { return null; }
    }

    function cacheSet(key, data) {
        try { sessionStorage.setItem(key, JSON.stringify({ data: data, expiresAt: Date.now() + CACHE_TTL_MS })); }
        catch (e) {}
    }

    function escapeHtml(s) {
        return String(s == null ? '' : s)
            .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    function fetchJson(url) {
        return fetch(url, { credentials: 'omit' }).then(function (r) {
            if (!r.ok) throw new Error('HTTP ' + r.status);
            return r.json();
        });
    }

    function formatRating(v) {
        if (v == null || isNaN(v)) return '―';
        var n = Number(v);
        return n.toFixed(1);
    }

    function buildRatingKeyMap(ratingKeys) {
        var map = {};
        (ratingKeys || []).forEach(function (r) { map[r.key] = r.label; });
        return map;
    }

    function reviewHandles(r) {
        if (r.product_handles && r.product_handles.length) return r.product_handles;
        if (r.product_handle) return [r.product_handle];
        return [];
    }

    function videoUrl(review) {
        if (!review) return '';
        if (typeof review.video === 'string') return review.video;
        if (review.video && review.video.url) return review.video.url;
        return '';
    }

    function videoPoster(review) {
        if (review && review.video && typeof review.video === 'object' && review.video.poster) return review.video.poster;
        if (review && review.photos && review.photos[0]) return review.photos[0].thumb || review.photos[0].full || '';
        return '';
    }

    function buildStaffUrl(staff, fallbackPageUrl) {
        staff = staff || {};
        if (staff.url) return staff.url;

        var staffSlug = staff.slug || '';
        var pageUrl = fallbackPageUrl || '/pages/staff';
        return staffSlug
            ? pageUrl + (pageUrl.indexOf('?') === -1 ? '?' : '&') + 'id=' + encodeURIComponent(staffSlug)
            : '#';
    }

    function productKind(productType) {
        var t = String(productType || '').toLowerCase();
        if (t.indexOf('リング') !== -1 || t.indexOf('ring') !== -1) return 'ring';
        if (t.indexOf('バングル') !== -1 || t.indexOf('ブレス') !== -1 || t.indexOf('bracelet') !== -1 || t.indexOf('bangle') !== -1) return 'wrist';
        if (t.indexOf('ピアス') !== -1 || t.indexOf('イヤ') !== -1 || t.indexOf('ear') !== -1) return 'ear';
        if (t.indexOf('ネックレス') !== -1 || t.indexOf('necklace') !== -1) return 'neck';
        return '';
    }

    function staffAttrsForProduct(staff, productType) {
        var kind = productKind(productType);
        var attrs = [];
        if (staff.body_type) attrs.push('<span>' + escapeHtml(staff.body_type) + '</span>');

        if (kind === 'ring') {
            if (staff.ring_size) attrs.push('<span>着用号数: ' + escapeHtml(staff.ring_size) + '</span>');
            else if (staff.finger_type_label) attrs.push('<span>着用号数: ' + escapeHtml(staff.finger_type_label) + '</span>');
        } else if (kind === 'wrist') {
            if (staff.wrist_size) attrs.push('<span>手首サイズ: ' + escapeHtml(staff.wrist_size) + '</span>');
        } else if (kind === 'ear') {
            if (staff.ear_size) attrs.push('<span>耳サイズ: ' + escapeHtml(staff.ear_size) + '</span>');
            if (staff.ear_type_label) attrs.push('<span>耳: ' + escapeHtml(staff.ear_type_label) + '</span>');
        } else if (kind === 'neck') {
            if (staff.neckline) attrs.push('<span>首サイズ: ' + escapeHtml(staff.neckline) + '</span>');
        } else {
            if (staff.ring_size) attrs.push('<span>着用号数: ' + escapeHtml(staff.ring_size) + '</span>');
            else if (staff.finger_type_label) attrs.push('<span>着用号数: ' + escapeHtml(staff.finger_type_label) + '</span>');
            if (staff.ear_size) attrs.push('<span>耳サイズ: ' + escapeHtml(staff.ear_size) + '</span>');
            else if (staff.ear_type_label) attrs.push('<span>耳: ' + escapeHtml(staff.ear_type_label) + '</span>');
            if (staff.wrist_size) attrs.push('<span>手首サイズ: ' + escapeHtml(staff.wrist_size) + '</span>');
            if (staff.neckline) attrs.push('<span>首サイズ: ' + escapeHtml(staff.neckline) + '</span>');
        }

        return attrs;
    }

    function renderSummary(root, data) {
        var summaryEl = root.querySelector('[data-staff-reviews-summary]');
        if (!summaryEl) return;

        var avg = data.average || {};
        var keys = data.rating_keys || [];
        var items = [];

        items.push('<span class="staff-reviews__summary-item">レビュー <strong>' + (data.count || 0) + '</strong> 件</span>');
        keys.forEach(function (k) {
            if (avg[k.key] != null) {
                items.push('<span class="staff-reviews__summary-item">' + escapeHtml(k.label) + ' <strong>' + formatRating(avg[k.key]) + '</strong></span>');
            }
        });

        summaryEl.innerHTML = items.join('');
    }

    function renderReviewCard(review, ratingKeyMap, staffPageUrl, productType) {
        var staff = review.staff || {};
        var staffName = staff.name || '';
        var staffSlug = staff.slug || '';
        var avatar    = staff.avatar || '';

        var attrs = staffAttrsForProduct(staff, productType);

        var mediaHtml = '';
        (review.photos || []).forEach(function (p) {
            mediaHtml += '<img src="' + escapeHtml(p.thumb || p.full) + '" data-full="' + escapeHtml(p.full) + '" alt="" loading="lazy">';
        });
        var vUrl = videoUrl(review);
        if (vUrl) {
            var poster = videoPoster(review);
            mediaHtml += '<video class="staff-reviews__video" src="' + escapeHtml(vUrl) + '"' +
                (poster ? ' poster="' + escapeHtml(poster) + '"' : '') +
                ' autoplay muted loop playsinline controls preload="metadata"></video>';
        }

        var ratingsHtml = '';
        if (review.avg_rating != null) {
            ratingsHtml += '<div class="staff-reviews__ratings-item staff-reviews__ratings-item--avg"><span>総合評価</span><strong>' + formatRating(review.avg_rating) + ' / 5.0</strong></div>';
        }
        if (review.ratings) {
            Object.keys(review.ratings).forEach(function (k) {
                var label = ratingKeyMap[k] || k;
                ratingsHtml += '<div class="staff-reviews__ratings-item"><span>' + escapeHtml(label) + '</span><strong>' + formatRating(review.ratings[k]) + '</strong></div>';
            });
        }

        var staffUrl = buildStaffUrl(staff, staffPageUrl);

        var comment = review.comment || (review.comment_plain ? escapeHtml(review.comment_plain).replace(/\r?\n/g, '<br>') : '');

        return '' +
            '<li class="staff-reviews__card">' +
                '<div class="staff-reviews__card-header">' +
                    (avatar
                        ? '<img class="staff-reviews__avatar" src="' + escapeHtml(avatar) + '" alt="" loading="lazy">'
                        : '<span class="staff-reviews__avatar staff-reviews__avatar--placeholder"></span>') +
                    '<div class="staff-reviews__staff-meta">' +
                        (staffSlug
                            ? '<a class="staff-reviews__staff-name" href="' + escapeHtml(staffUrl) + '">' + escapeHtml(staffName) + '</a>'
                            : '<span class="staff-reviews__staff-name">' + escapeHtml(staffName) + '</span>') +
                        (attrs.length ? '<div class="staff-reviews__staff-attrs">' + attrs.join('') + '</div>' : '') +
                    '</div>' +
                '</div>' +
                (mediaHtml ? '<div class="staff-reviews__media">' + mediaHtml + '</div>' : '') +
                (ratingsHtml ? '<div class="staff-reviews__ratings">' + ratingsHtml + '</div>' : '') +
                (comment ? '<div class="staff-reviews__comment">' + comment + '</div>' : '') +
                (staffSlug
                    ? '<div class="staff-reviews__footer">' +
                        '<a class="staff-reviews__more" href="' + escapeHtml(staffUrl) + '">このスタッフのレビュー一覧 ≫</a>' +
                      '</div>'
                    : '') +
            '</li>';
    }

    function openLightbox(src) {
        var box = document.createElement('div');
        box.className = 'staff-reviews-lightbox';
        box.innerHTML = '<img src="' + escapeHtml(src) + '" alt="">';
        box.addEventListener('click', function () { box.remove(); });
        document.body.appendChild(box);
    }

    function bindLightbox(root) {
        if (root.dataset.lightboxBound === 'true') return;
        root.dataset.lightboxBound = 'true';

        root.addEventListener('click', function (e) {
            var img = e.target.closest('.staff-reviews__media img');
            if (!img) return;
            var full = img.dataset.full || img.src;
            openLightbox(full);
        });
    }

    function startAutoplay(root) {
        root.querySelectorAll('video[autoplay]').forEach(function (video) {
            video.muted = true;
            video.playsInline = true;
            var playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(function () {});
        });
    }

    function initProductPageReviews(root) {
        var apiBase = (root.dataset.apiBase || '').replace(/\/+$/, '');
        var handle  = root.dataset.productHandle;
        var productType = root.dataset.productType || '';
        var staffPageUrl = root.dataset.staffPageUrl || '/pages/staff';
        if (!apiBase || !handle) return;

        var cacheKey = 'sr:reviews:' + handle;
        var cached = cacheGet(cacheKey);

        function render(data) {
            var listEl = root.querySelector('[data-staff-reviews-list]');
            if (!data || !data.reviews || data.reviews.length === 0) {
                root.hidden = true;
                return;
            }
            var ratingKeyMap = buildRatingKeyMap(data.rating_keys);
            renderSummary(root, data);
            listEl.innerHTML = data.reviews.map(function (r) { return renderReviewCard(r, ratingKeyMap, staffPageUrl, productType); }).join('');
            bindLightbox(root);
            startAutoplay(root);
        }

        if (cached) render(cached);

        fetchJson(apiBase + '/reviews/by-handle/' + encodeURIComponent(handle))
            .then(function (data) { cacheSet(cacheKey, data); render(data); })
            .catch(function (err) {
                console.warn('[staff-reviews] fetch failed', err);
                if (!cached) root.hidden = true;
            });
    }

    function initStaffPage(root) {
        var apiBase = (root.dataset.apiBase || '').replace(/\/+$/, '');
        if (!apiBase) {
            root.innerHTML = '<p style="text-align:center;color:#999;">APIが未設定です。テーマ設定を確認してください。</p>';
            return;
        }
        var params = new URLSearchParams(window.location.search);
        var id = params.get('id');
        if (id) renderStaffDetail(root, apiBase, id);
        else    renderStaffList(root, apiBase);
    }

    function renderStaffList(root, apiBase) {
        fetchJson(apiBase + '/staff').then(function (staff) {
            var html = '<h1 class="staff-page__heading">スタッフ一覧</h1>' +
                       '<p class="staff-page__subheading">各スタッフの着用レビューから商品を探せます</p>';
            if (!staff || staff.length === 0) {
                html += '<p style="text-align:center;color:#999;">スタッフが登録されていません。</p>';
                root.innerHTML = html;
                return;
            }
            html += '<ul class="staff-page__list">';
            staff.forEach(function (s) {
                var url = buildStaffUrl(s, window.location.pathname);
                html += '<li>' +
                    '<a class="staff-page__staff-card" href="' + escapeHtml(url) + '">' +
                        (s.avatar
                            ? '<img class="staff-page__staff-avatar" src="' + escapeHtml(s.avatar) + '" alt="" loading="lazy">'
                            : '<div class="staff-page__staff-avatar"></div>') +
                        '<div class="staff-page__staff-name">' + escapeHtml(s.name) + '</div>' +
                        '<div class="staff-page__staff-count">レビュー ' + (s.review_count || 0) + ' 件</div>' +
                    '</a>' +
                '</li>';
            });
            html += '</ul>';
            root.innerHTML = html;
        }).catch(function () {
            root.innerHTML = '<p style="text-align:center;color:#b32d2e;">スタッフ情報の取得に失敗しました。</p>';
        });
    }

    function renderStaffDetail(root, apiBase, slug) {
        fetchJson(apiBase + '/staff/' + encodeURIComponent(slug)).then(function (data) {
            if (!data || !data.staff) {
                root.innerHTML = '<p style="text-align:center;color:#999;">該当のスタッフが見つかりません。<br><a href="?">スタッフ一覧へ戻る</a></p>';
                return;
            }
            var s = data.staff;
            var html = '<p style="margin-bottom:16px;"><a href="?">← スタッフ一覧へ戻る</a></p>';

            html += '<div class="staff-detail__profile">';
            html += s.avatar
                ? '<img class="staff-detail__avatar" src="' + escapeHtml(s.avatar) + '" alt="">'
                : '<div class="staff-detail__avatar"></div>';
            html += '<div class="staff-detail__info">';
            html += '<h1 class="staff-detail__name">' + escapeHtml(s.name) + '</h1>';

            var attrs = [];
            if (s.body_type)         attrs.push({ l: '身長・体型', v: s.body_type });
            if (s.ring_size)         attrs.push({ l: '着用号数',   v: s.ring_size });
            else if (s.finger_type_label) attrs.push({ l: '着用号数', v: s.finger_type_label });
            if (s.ear_size)          attrs.push({ l: '耳サイズ',   v: s.ear_size });
            else if (s.ear_type_label) attrs.push({ l: '耳タイプ', v: s.ear_type_label });
            if (s.wrist_size)        attrs.push({ l: '手首サイズ', v: s.wrist_size });
            if (s.neckline)          attrs.push({ l: '首回り',     v: s.neckline });
            if (attrs.length) {
                html += '<dl class="staff-detail__attrs">';
                attrs.forEach(function (a) {
                    html += '<dt>' + escapeHtml(a.l) + ':</dt><dd>' + escapeHtml(a.v) + '</dd>';
                });
                html += '</dl>';
            }
            if (s.profile) html += '<div class="staff-detail__profile-text">' + escapeHtml(s.profile) + '</div>';
            html += '</div></div>';

            html += '<h2 style="font-size:16px;font-weight:600;margin-bottom:12px;">このスタッフのコーデ一覧（' + (data.count || 0) + ' 件）</h2>';

            if (!data.reviews || data.reviews.length === 0) {
                html += '<p style="color:#999;">まだレビューがありません。</p>';
            } else {
                html += '<ul class="staff-detail__coords">';
                data.reviews.forEach(function (r) {
                    var photo   = (r.photos && r.photos[0]) ? (r.photos[0].thumb || r.photos[0].full) : '';
                    var vUrl = videoUrl(r);
                    var poster = videoPoster(r);
                    var hasVideo = !!vUrl;
                    var handles = reviewHandles(r);
                    if (handles.length === 0) return;
                    var primary = handles[0];
                    var moreBadge = handles.length > 1
                        ? '<span style="font-size:10px;color:#a38f51;margin-left:4px;">+' + (handles.length - 1) + '件</span>'
                        : '';
                    html += '<li>' +
                        '<a class="staff-detail__coord" href="/products/' + encodeURIComponent(primary) + '">' +
                            (hasVideo
                                ? '<video class="staff-detail__coord-video" src="' + escapeHtml(vUrl) + '"' +
                                    (poster ? ' poster="' + escapeHtml(poster) + '"' : '') +
                                    ' autoplay muted loop playsinline preload="metadata"></video>'
                                : photo
                                ? '<img src="' + escapeHtml(photo) + '" alt="" loading="lazy">'
                                : '<div style="width:100%;aspect-ratio:3/4;background:#f0f0f0;border-radius:3px;margin-bottom:6px;"></div>') +
                            (hasVideo ? '<span class="staff-detail__video-badge">動画</span>' : '') +
                            '<div class="staff-detail__coord-handle">' + escapeHtml(primary) + moreBadge + '</div>' +
                        '</a>' +
                    '</li>';
                });
                html += '</ul>';
            }

            root.innerHTML = html;
            startAutoplay(root);
        }).catch(function () {
            root.innerHTML = '<p style="text-align:center;color:#b32d2e;">スタッフ情報の取得に失敗しました。</p>';
        });
    }

    document.addEventListener('DOMContentLoaded', function () {
        document.querySelectorAll('[data-staff-reviews]').forEach(initProductPageReviews);
        document.querySelectorAll('[data-staff-page]').forEach(initStaffPage);
    });
})();
